/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './individual';
import './business';
import './controlling_individual';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "ApplicationFlow": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.sfs.external.models.ApplicationFlow.Status",
                        "id": 2,
                        "rule": "optional"
                      },
                      "individual": {
                        "type": "squareup.sfs.external.models.Individual",
                        "id": 3,
                        "rule": "optional"
                      },
                      "accountId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "business": {
                        "type": "squareup.sfs.external.models.Business",
                        "id": 5,
                        "rule": "optional"
                      },
                      "ineligibleReason": {
                        "type": "squareup.sfs.external.models.ApplicationFlow.IneligibleReason",
                        "id": 6,
                        "rule": "optional"
                      },
                      "bankcBalanceId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "controllingIndividuals": {
                        "type": "squareup.sfs.external.models.ControllingIndividual",
                        "id": 8,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "AF_STATUS_DO_NOT_USE": 0,
                          "OPEN": 1,
                          "AGREEMENTS_ACCEPTED": 2,
                          "IDV_COMPLETED": 3,
                          "BANK_CUSTOMER_CREATED": 4,
                          "SUCCEEDED": 5,
                          "INELIGIBLE": 6,
                          "ERRORED": 7,
                          "RESUBMITTED": 10,
                          "TIN_COMPLETED": 11,
                          "DOCUMENTS_REQUESTED": 12,
                          "IN_MANUAL_REVIEW": 13
                        }
                      },
                      "IneligibleReason": {
                        "values": {
                          "NONE": 0,
                          "OFAC_HIT": 1,
                          "SUSPENDED": 2,
                          "MAX_IDV_ATTEMPTS": 3,
                          "LE_INELIGIBLE": 4,
                          "MERCHANT_INELIGIBLE": 5,
                          "HISTORY_INSUFFICIENT": 6,
                          "NON_SOLE_PROP": 7,
                          "LE_MISSING": 8,
                          "AGE": 9,
                          "CANNOT_ACCEPT_PAYMENTS": 10,
                          "NON_US": 11,
                          "INCOMPLETE_LE_DATA": 12,
                          "INVALID_TIN": 13,
                          "INVALID_US_ADDRESS": 14,
                          "MANUAL_REVIEW_REJECTION": 15,
                          "LE_PRIMARY_INDIVIDUAL_NOT_FOUND": 16,
                          "RISK_DECLINED": 17
                        }
                      },
                      "TaxTinType": {
                        "values": {
                          "AF_TAX_TIN_TYPE_DO_NOT_USE": 0,
                          "SSN": 1,
                          "EIN": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlow && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlow?.nested?.Status && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlow?.nested?.IneligibleReason && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlow?.nested?.TaxTinType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc SFS ApplicationFlow. SUCCEEDED and INELIGIBLE are terminal states.
 * --
 *
 * SOURCE ApplicationFlow @ squareup/sfs/external/models/application_flow.proto at 13:1
 */
export const ApplicationFlow = $root.lookupType('squareup.sfs.external.models.ApplicationFlow');
fixType(ApplicationFlow, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ApplicationFlow);
/**
 * SOURCE Status @ squareup/sfs/external/models/application_flow.proto at 14:3
 */
ApplicationFlow.Status = $root.lookupEnum('squareup.sfs.external.models.ApplicationFlow.Status').values;
/**
 * SOURCE IneligibleReason @ squareup/sfs/external/models/application_flow.proto at 31:3
 */
ApplicationFlow.IneligibleReason = $root.lookupEnum('squareup.sfs.external.models.ApplicationFlow.IneligibleReason').values;
/**
 * SOURCE TaxTinType @ squareup/sfs/external/models/application_flow.proto at 52:3
 */
ApplicationFlow.TaxTinType = $root.lookupEnum('squareup.sfs.external.models.ApplicationFlow.TaxTinType').values;